import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { HttpStoreInfo } from "../../http";
import { AppConfigFields, ContactInfoFields } from "../../types/appConfigEntities";
import { TiendaSecurityObjects } from "../../types/security/SecurityObjects";
import { SafetyComponent } from "../security/SafetyComponent";

interface Props {
    productId: string;
    productName: string;
    productSku: string;
}

export const ProductWhatsappConsultButton: React.FC<Props> = ({
    productId,
    productName,
    productSku,
}) => {
    const [isCatalogPlan, setIsCatalogPlan] = useState<boolean | null>(null);

    useEffect(() => {
        let active = true;
        HttpStoreInfo.get()
            .then((response) => active && setIsCatalogPlan(response.esCatalogo))
            .catch(() => active && setIsCatalogPlan(null));
        return () => {
            active = false;
        };
    }, []);

    if (isCatalogPlan !== true) return null;

    const contactInfo = window.APP_CONFIG?.[AppConfigFields.ContactData];
    const phone = contactInfo?.[ContactInfoFields.Whatsapp]?.replace(/\D/g, "");
    if (!phone) return null;

    const message = `Hola, quiero consultar por ${productName} (SKU: ${productSku}). ${window.location.href}`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    const handleClick = () => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <SafetyComponent
            objectCode={TiendaSecurityObjects.ProductWhatsappConsultButton}
            require="read"
        >
            <Button fullWidth variant="outlined" startIcon={<WhatsAppIcon />} onClick={handleClick}>
                CONSULTAR POR WHATSAPP
            </Button>
        </SafetyComponent>
    );
};
